<template>
  <div>
    <div
      style="white-space:pre"
      class="bgImg d-flex align-items-sm-center justify-content-center justify-content-sm-start"
    >
      <div class="textStyle pt-5">{{ showHBDName }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: () => ({}),
  computed: {
    ...mapGetters(['roster', 'impersonateMail']),
    showHBDName() {
      const status = this.roster[0].actvName
      switch (status) {
        case 'HAPPY BIRTHDAY\nAND ANNIVERSARY':
          return status
        case 'HAPPY BIRTHDAY':
          return status
        case 'HAPPY ANNIVERSARY':
          return status
        default:
          return ''
      }
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.bgImg {
  background-color: rgba(102, 159, 166, 1);
  height: 172px;
  @media (max-width: 480px) {
    width: 90%;
    margin: auto;
    // height: 240px;
  }

  .textStyle {
    font-family: 'starlux';
    font-size: 38px;
    color: #fff;
    filter: drop-shadow(2px 2px 0px rgba(0, 0, 0, 0.16));
    padding-left: 40px;
    @media (max-width: 480px) {
      font-size: 30px;
      padding-left: 0;
      padding-top: 10px !important;
    }
  }
}
</style>
